module.exports = __webpack_public_path__ + "img/ghost.20a46e63.svg";